import { Component } from '@angular/core';

@Component({
  selector: 'app-print-asset-vehicle-link',
  templateUrl: './print-asset-vehicle-link.component.html',
  styleUrls: ['./print-asset-vehicle-link.component.scss']
})
export class PrintAssetVehicleLinkComponent {

}
